import gql from 'graphql-tag';

export default gql`
  fragment salesforceCampaignMemberFieldSelectOptionFragment on SalesforceCampaignMemberFieldSelectOption {
    id
    isActive
    isDefault
    label
    value
  }
`;
